export function shareButton(){
    document.addEventListener('DOMContentLoaded', (event) => {

        document.querySelectorAll('.shareButton').forEach((el) => {
            el.addEventListener('click', () => {
                let currentLink = el.getAttribute('data-share-link');
                if (window.isSecureContext && navigator.clipboard) {
                    navigator.clipboard.writeText(currentLink);
                    toogleTooltip(el)
                } else {
                    unsecuredCopyToClipboard(currentLink, el);
                }
            })
        });

        const unsecuredCopyToClipboard = (text,el) => {
            const textArea = document.createElement("textarea");
            textArea.value=text;
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            try{
                document.execCommand('copy');
                toogleTooltip(el)
            }
            catch(err){
                console.error('Unable to copy to clipboard',err)}
                document.body.removeChild(textArea)
            };

        function toogleTooltip(el){
            el.classList.add('tooltipActive');
            setTimeout(()=>{el.classList.remove('tooltipActive')},3000);
        }
    });
}
